export default __webpack_public_path__ + "locales/sr-Latn-RS/Translations.json?hash=4f6cde032f9e101d1c7a91c8704b7398";